module.exports = "<div style=\"text-align:center\">\n\n  <app-card-template [navlinks]=navLinks></app-card-template >\n  \n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /home/hkk/source/crazyaboutmath/src/app/menu-fractions/menu-fractions.component.html
// module id = ../../../../../src/app/menu-fractions/menu-fractions.component.html
// module chunks = main